<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["which_location"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["select_location"] }}
      </p>
      <div
        class="car"
        v-for="item in residentsLocations"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            {{ item.name || "" }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.residentsLocations = [
        ...new Map(
          this.$store.getters.RESIDENTS.map((resident) => [
            resident.location.id,
            resident.location
          ])
        ).values()
      ];
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      requestType: "PARKENDA",
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      residentsLocations: [],
      next: (item) => {
        const residents = this.$store.getters.RESIDENTS;

        this.$store.dispatch("SET_RESIDENTS_TAGS", getTagsForLocation(item.id));
        if (getTagsForLocation(item.id).length === 1) {
          this.$store.dispatch(
            "SET_SELECTED_RESIDENT_TAG",
            getTagsForLocation(item.id)[0]
          );
          this.$router.push("/tagDetails");
        } else {
          this.$router.push("/selectTag");
        }
        function getTagsForLocation(locationId) {
          const tagsArray = residents
            .filter((resident) => resident.location.id === locationId)
            .flatMap((resident) => resident.tags);
          return tagsArray;
        }
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/Residential/SelectLocation.vue